import { reducer as formReducer } from 'redux-form'
import update from 'react-addons-update';
import deepCopy from 'deepcopy'

let continueNodeId = (new Date).getTime();

var miniPageBuilder = [];


const formReducers = formReducer.plugin({

        sppbForm: (state, action) => {   // <----- 'sppbForm' is name of form given to reduxForm()

            switch(action.type) {
                case 'SAVE_ADDON_IN':
                case 'UPDATE_ADDON_IN':
                case 'REMOVE_ADDON_IN':
                case 'SORT_ADDON_IN':

                    const { fieldData } = action

                    var cloneItem = jQuery.extend(true, {}, state.values[fieldData.fieldName][fieldData.rfieldIndex])
                    var newItem = changeObjectId(cloneItem, action);

                    return update(state, {
                      values: {
                          [fieldData.fieldName]: {
                              $splice: [[fieldData.rfieldIndex, 1, newItem]]
                          }
                      }
                    });

                default:
                    return state
            }
        }
    });


const changeObjectId = (item, action) => {
    const { fieldData } = action

    switch (action.type) {

      case 'SAVE_ADDON_IN':
        var contents = item[fieldData.riFieldName];
        if (contents == undefined || contents == '') {

          var newMiniPageBuilder = deepCopy(miniPageBuilder);

          newMiniPageBuilder.push({
                id: continueNodeId++,
                name: fieldData.addonName,
                settings: action.formVal
            })
            item[fieldData.riFieldName] = newMiniPageBuilder
        } else {
          item[fieldData.riFieldName].push({
                id: continueNodeId++,
                name: fieldData.addonName,
                settings: action.formVal
            })
        }
        return item;

      case 'UPDATE_ADDON_IN':
          item[fieldData.riFieldName][fieldData.addonIndex].settings = action.formVal
          return item;

      case 'REMOVE_ADDON_IN':

        return update(item, {
              [action.riFieldName] : {
                $splice: [
                  [action.addonIndex, 1]
                ]
              }
            });

      case 'SORT_ADDON_IN':

        var dragIndex = action.dragIndex,
            hoverIndex = action.dropIndex;
        var dragItem = item[action.riFieldName][dragIndex];

        return update(item, {
            [action.riFieldName] : {
              $splice: [
                [dragIndex, 1],
                [hoverIndex, 0, dragItem]
              ]
            }
          });

        default:
          return item;

    }
}

const changeColumnLayout = ( columns, action ) => {
    var cloneCols   = columns,
        layout      = action.layout,
        current     = action.current;

    if (layout == '12') {
      var layoutArray   = [12];
    } else {
      var layoutArray   = layout.split(',')
    }

    if (current == '12') {
      var activeLayout  = [12];
    } else {
      var activeLayout  = current.split(',')
    }

    var newLength       = layoutArray.length,
        currentLength   = activeLayout.length;

    var newColumns  = [];

    for ( var i = 0; i < newLength; i++ ) {
      var element = layoutArray[i],
          newClassName = 'col-md-' + element;

      if (typeof cloneCols[i] !== 'undefined') {
        cloneCols[i].class_name = newClassName;
        newColumns.push(cloneCols[i]);
      } else {
        var newCoulmn = {
          id: continueNodeId++,
          class_name: newClassName,
          settings: {},
          addons: []
        };

        newColumns.push(newCoulmn);
      }
    }

    if ( newLength < currentLength ) {
      var index = newLength - 1,
          restList = [];

      for ( var i = newLength; i < currentLength; i++ ) {
        var restAddons = cloneCols[i].addons;
        if(restAddons.length > 0){
          restList = restList.concat(restAddons);
        }
      }

      if (restList.length > 0) {
        newColumns[index].addons = newColumns[index].addons.concat(restList);
      }
    };

    return {
      layout: layout,
      columns: newColumns
    }
}

export default formReducers;



// WEBPACK FOOTER //
// ./src/helpers/form/reducers/FormReducer.js